// eslint-disable-next-line import/prefer-default-export
export const DUREE_PERIODE_AN_DEFAUT = 1;



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/dateFiltreConf.js